import React from 'react';

import MapSettings from 'components/Account/MapSettings';

export default function Preferences() {
  return (
    <MapSettings />
  );
}

Preferences.displayName = 'Preferences';
